import React from "react";
import { LocalWrapper, Wrapper } from "./styles";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const history = useHistory();
  const pathname = history.location.pathname;

  function changeLanguage(lang) {
    i18n.changeLanguage(lang);
    localStorage.setItem("culture", lang);
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("lang", lang);
    window.history.replaceState({}, "", currentUrl);
  }

  return (
    <Wrapper>
      <LocalWrapper
        onClick={() => {
          changeLanguage("ka");
        }}
        isActive={i18n.language === "ka"}
      >
        geo
      </LocalWrapper>
      <LocalWrapper
        onClick={() => {
          changeLanguage("en");
        }}
        isActive={i18n.language === "en"}
      >
        eng
      </LocalWrapper>
    </Wrapper>
  );
}

export default LanguageSwitcher;
